import React, { useEffect, useState } from "react";
import { getCollectionById } from "../api";
import ProductGrid from "../../products/components/ProductGrid";
import LoadMoreButton from "../../../shared/ui/LoadMoreButton";
import { mergeProducts } from "../../products/utils/productDisplay";
import Loading from "../../../shared/ui/Loading";
import NoResults from "../../../shared/ui/NoResults";
import CollectionBanner from "./CollectionBanner";
import Seo from "../../../shared/ui/Seo";

const PAGE_SIZE = 18;

// Products of one collection, loaded a page at a time. Title and banner come from the collection itself.
// The parent keys this by slug, so another collection starts from a fresh state.
const CollectionProducts = ({ slug }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [collectionData, setCollectionData] = useState(null);

  useEffect(() => {
    let ignore = false;
    setLoading(true);
    getCollectionById(slug, currentPage, PAGE_SIZE)
      .then((data) => {
        if (ignore) return;
        setCollectionData(data);
        setProducts((prev) => mergeProducts(prev, data?.publicProducts?.content || [], currentPage));
        setTotalPages(data?.publicProducts?.totalPages || 1);
      })
      .catch((error) => console.error("Error fetching collection data:", error))
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [slug, currentPage]);

  const title = collectionData?.displayName;
  const seo = (
    <Seo
      title={title}
      description={title ? `Shop ${title} at Bigmall - great prices in Sri Lanka with island-wide delivery.` : undefined}
      noindex={!loading && products.length === 0}
    />
  );

  if (loading && products.length === 0) {
    return (
      <>
        {seo}
        <Loading message="Loading products..." />
      </>
    );
  }
  if (products.length === 0) {
    return (
      <>
        {seo}
        <NoResults message="No products found" />
      </>
    );
  }

  return (
    <>
      {seo}
      <CollectionBanner images={collectionData?.images} />
      <ProductGrid
        products={products}
        currentPage={currentPage}
        totalPages={totalPages}
        showLoadmore={false}
        title={title}
      />
      <div className="container">
        <LoadMoreButton
          hasMore={currentPage < totalPages - 1}
          loading={loading}
          onClick={() => setCurrentPage((page) => page + 1)}
        />
      </div>
    </>
  );
};

export default CollectionProducts;
